import { render, staticRenderFns } from "./AdminPrivacyTerms.vue?vue&type=template&id=5768c98d&scoped=true&"
import script from "./AdminPrivacyTerms.vue?vue&type=script&lang=ts&"
export * from "./AdminPrivacyTerms.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPrivacyTerms.vue?vue&type=style&index=0&id=5768c98d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768c98d",
  null
  
)

export default component.exports